import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import TemplateLibraryIcon from "../../assets/icons/template_rec.svg2";
import MyBadge from "../Common/MyBadge";
import MySearch from "../Common/MySearch";
import WhiteButton from "../Common/WhiteButton";
import MyTemplateCard from "./MyTemplateCard";
import TemplateDetail from "./TemplateDetail";
import EngineerVisitIcon from "../../assets/icons/engineer.svg2";
import TickIcon from "../../assets/icons/tick.svg2";
import ApiDataCollection from "../API/ApiDataCollection";
import MyModal from "../Common/MyModal";
import {
  useDeleteApiDataCollectionMutation,
  useGetApiDataCollectionsQuery,
} from "../store/slices/settingsSlice";
import HelpButton from "../HelpContent/HelpButton";
import { useConfirmDialog } from "../Builder/Components/ConfirmDialogContext";

export default function APIDataCollections({
  ApiProfile,
}: {
  ApiProfile?: { Uuid: string; BaseUrl: string };
}) {
  const confirmDialog = useConfirmDialog() as
    | ((title: string, message: string) => Promise<boolean>)
    | null;
  const [selectedTemplate, setSelectedTemplate] = useState<any>();
  const [search, setSearch] = useState("");

  const {
    data: { collections: availableTemplates, total: totalResults } = {
      collections: [],
      total: 0,
    },
  } = useGetApiDataCollectionsQuery(
    {
      uuid: ApiProfile?.Uuid || undefined,
      search,
      offset: 0,
      limit: 1000,
    },
    { skip: !ApiProfile?.Uuid }
  );

  useEffect(() => {
    if (availableTemplates && availableTemplates.length > 0) {
      setSelectedTemplate(availableTemplates[0]);
    }
  }, [availableTemplates]);

  const [deleteAPICollection] = useDeleteApiDataCollectionMutation();

  return (
    <div>
      <div className="mb-3 bg-colored-reverse p-3 rounded-3 d-flex justify-content-between gap-3 align-items-end">
        <MySearch
          placeholder="Search for a data structure"
          value={search}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setSearch(e.target.value);
          }}
        />
        <MyModal
          label={
            <WhiteButton
              as="span"
              icon={TemplateLibraryIcon}
              heading="Add"
              subheading="Data Structure"
              target={undefined}
              disabled={false}
            />
          }
          size="xl"
          heading="Add Data Structure"
        >
          <ApiDataCollection ApiProfile={ApiProfile} />
        </MyModal>
      </div>
      {/* / */}
      <Row className="mb-5 my-3 ">
        <Col xs={12} lg={4} className="pe-5 border-end border-2">
          <div
            style={{
              maxHeight: 500,
              overflowY: "auto",
              scrollbarColor: "purple",
            }}
            className="pe-2 fw-bold"
          >
            <span className="fs-3">
              Data structures <HelpButton helpKey="api-data-structures" />
            </span>
            <MyBadge count={totalResults} />
            {availableTemplates?.map((template) => (
              <MyTemplateCard
                key={template.Uuid}
                isSelected={selectedTemplate === template}
                onSelect={() => setSelectedTemplate(template)}
              >
                <div>{template.Label}</div>
              </MyTemplateCard>
            ))}
          </div>
          {/* <MyPagination total={totalResults} onPaginate={loader} /> */}
        </Col>
        <div className="col-lg-1"></div>
        <Col className="fw-bold">
          {selectedTemplate && (
            <>
              About this data structure:
              <div className="my-3">
                <div
                  className={`btn w-75 h-100 px-0  text-start rounded-3 position-relative `}
                >
                  <div className="d-flex align-items-center">
                    <div className="bg-purple-gradient rounded-circle me-3">
                      <EngineerVisitIcon width={60} />
                    </div>
                    <div className="me-3">
                      <h3 className="text-black fw-bold">
                        {selectedTemplate.Label}
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="fw-bold my-4">
                  This data structure has the following details:
                </div>
                <Row>
                  <div className="col-6">
                    <TemplateDetail
                      label="Label"
                      value={selectedTemplate.Label || "No label defined"}
                      Icon={undefined}
                    />
                  </div>
                  <div className="col-6">
                    <TemplateDetail
                      label="Path"
                      value={selectedTemplate.Path}
                      Icon={undefined}
                    />
                  </div>

                  <div className="col-6">
                    <TemplateDetail
                      label="Fields"
                      value={
                        selectedTemplate.Fields?.map(
                          (field: { Path: string }) => field.Path
                        ).join(", ") ?? "No fields defined."
                      }
                      Icon={undefined}
                    />
                  </div>
                </Row>
              </div>
              <div className="d-flex justify-content-start my-5">
                <MyModal
                  label={
                    <div className="d-flex align-items-center ">
                      <TickIcon
                        width={40}
                        className=" white rounded-circle p-1"
                      />
                      <h5 className="my-0 mx-3 text-white">Edit</h5>
                    </div>
                  }
                  buttonClassName="btn bg-colored-reverse rounded-pill px-3"
                  size="xl"
                  heading={<><span>Edit Data Structure</span> <HelpButton  helpKey="api-data-structures-edit"/></>}
                >
                  <ApiDataCollection
                    apiDataCollectionUUID={selectedTemplate.Uuid}
                  />
                </MyModal>

                <Button
                  className="btn bg-colored-reverse rounded-pill ms-2 px-3 border-0"
                  onClick={async () => {
                    if (!confirmDialog) {
                      return;
                    }
                    const ans = await confirmDialog(
                      "Are you sure?",
                      `Are you sure you want to delete this template? <br> ${selectedTemplate.Label}`
                    );
                    if (ans) {
                      deleteAPICollection(selectedTemplate.Uuid);
                    }
                  }}
                >
                  <div className="d-flex align-items-center ">
                    <h5 className="my-0 mx-3 text-white">Delete</h5>
                  </div>
                </Button>
              </div>
            </>
          )}
        </Col>
      </Row>
    </div>
  );
}
